import React from 'react';
import * as R from 'ramda';
import {useTranslation} from 'react-i18next';
import {Row, Col} from 'reactstrap';
import {Select} from '@/Form';
import {buildSelectOptions} from '@/components/Form/formHelper';

const CreditCardExpiry = () => {
  const {t: tr} = useTranslation('selection');
  const currentYear = new Date().getFullYear();
  const years = R.map(i => [i, i], R.range(currentYear - 1, currentYear + 6));

  return (
    <Row>
      <Col md={12}>
        <label>{tr('report:cc_expiry_date')}</label>
        <Row>
          <Col md={2}>
            <Select name='expiryFromYear'>{buildSelectOptions(years)}</Select>
          </Col>
          <label htmlFor='slash' className='mt-1'>
            /
          </label>
          <Col md={2}>
            <Select name='expiryFromMonth'>
              {buildSelectOptions(tr('month_options'))}
            </Select>
          </Col>
          <label className='mt-1'>{tr('report:to')}</label>
          <Col md={2}>
            <Select name='expiryToYear'>{buildSelectOptions(years)}</Select>
          </Col>
          <label htmlFor='slash' className='mt-1'>
            /
          </label>
          <Col md={2}>
            <Select name='expiryToMonth'>
              {buildSelectOptions(tr('month_options'))}
            </Select>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default CreditCardExpiry;
